import {searchReportEmployeeSales} from "../../../serviceBroker/transationReportApiServiceBroker";
import React, {FC} from "react";
import {PageEnum, TransactionReportSearchParamsModel} from "../../../models";
import {ReportPage, ReportTransactionSearchPanel} from "../../../components";
import {getPageNameByPageId, getSystemLanguageId} from "../../../utils";

export const ReportEmployeeSales: FC = () => {
    const initialState: TransactionReportSearchParamsModel = {
        Lang: getSystemLanguageId(),
        lang: getSystemLanguageId(),
    };
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchReportEmployeeSales}
            searchHeader={getPageNameByPageId(PageEnum.ReportEmployeeSales)}
            SearchPanel={ReportTransactionSearchPanel}
            formId={PageEnum.ReportEmployeeSales}
        />
    );
};
